import React from "react";

export default function SettingsSheetButton({ icon, label, onClick, children, className = "", tone = "default" }) {
  return (
    <button
      type="button"
      onClick={onClick}
      className={`qk-settings-row ${tone === "danger" ? "is-danger" : ""} ${className}`}
    >
      <span className="qk-settings-row-icon">{icon}</span>
      <span className="qk-settings-row-label">{label}</span>
      {children}
    </button>
  );
}
